export const SET_PAYS = "SET_PAYS";
export const SET_PAY = "SET_PAY";
export const SET_USERID = "SET_USERID";
export const SET_REFRESH_PAYS = "SET_REFRESH_PAYS";